import { CartItem } from 'common/api/e-comm/models/CartItem';
import { Product } from 'common/api/e-comm/models/Product';

export const potentialCartItemMatches = (cartItem: CartItem, product: Product) => {
    return product.variants.filter((variant) =>
        variant.options.every((o) => {
            const selectedOption = cartItem.selectedOptions[o.optionId];

            return !selectedOption || selectedOption === o.value;
        })
    );
};
